import produce from 'immer';
import {
	FETCH_COUNTRIES_FAILED,
	FETCH_COUNTRIES_FULFILLED,
	FETCH_COUNTRIES_PENDING,
} from '../constants/actions/countriesReducer';
import ICountriesReducer from '../interfaces/reducers/countriesReducer';

const initialValues: ICountriesReducer = {
	countries: null,
	countriesLoading: false,
	countriesError: false,
};

const countriesReducer = produce((draft: ICountriesReducer, action) => {
	switch (action.type) {
		case FETCH_COUNTRIES_PENDING: {
			draft.countriesLoading = true;
			draft.countriesError = false;
			break;
		}
		case FETCH_COUNTRIES_FULFILLED: {
			draft.countriesLoading = false;
			draft.countries = action.payload.countries;
			draft.countriesError = false;
			break;
		}
		case FETCH_COUNTRIES_FAILED: {
			draft.countriesLoading = false;
			draft.countriesError = true;
			break;
		}
		default: {
			break;
		}
	}
}, initialValues);

export default countriesReducer;
